import { Result } from 'antd';
import DataGrid, {
    Column,
    HeaderFilter,
    Pager,
    Paging,
    Scrolling,
    SearchPanel,
    Summary,
    TotalItem,
    Toolbar,
    Item as ToolbarItem
} from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import useHasPermission from 'hooks/useHasPermission';
import moment from 'moment';
import { getAllDiscountData } from 'pages/Componets/API_Modal/DiscountAPI/DiscountAPIModal';
import React, { useCallback, useState } from 'react';
import { Card } from 'react-bootstrap';
import AddDiscount from './AddDiscount';
import ActionButtons from './ActionButtons';
import { formatNumber } from 'devextreme/localization';
import type { ValueChangedEvent } from 'devextreme/ui/date_range_box';
import DateRangeBox from 'devextreme-react/date-range-box';

const DiscountMasterDataList = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const HasPermission = useHasPermission();

    const [dateRange, setDateRange] = useState<any>(['', '']);

    function formatDateTime(date: Date): string {
        const pad = (n: number) => n.toString().padStart(2, '0');
        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1);
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0]; // e.g., "2025-10-28"
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const { searchValue } = loadOptions;
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();

                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (dateRange) {
                        parameterList.append('FromDate', formatDate(dateRange[0]));
                        parameterList.append('ToDate', formatDate(dateRange[1]));
                    }

                    if (searchValue) {
                        parameterList.append('search', searchValue);
                    }

                    const response = await getAllDiscountData(parameterList);
                    return response;
                } catch (error) {
                    console.error('Data loading error:', error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };

    // const onCurrentValueChange = useCallback((e: ValueChangedEvent) => {
    //     const value = e.value as [Date, Date] | null | undefined;

    //     if (value?.[0] && value?.[1]) {
    //         // Both dates selected
    //         setSelectedRange([value[0], value[1]]);
    //         setRefreshKey((prev) => prev + 1);
    //     } else {
    //         // Range cleared
    //         setSelectedRange(null);
    //     }
    // }, []);
    const onCurrentValueChange = (e: any) => {
        setDateRange(e.value);
    };

    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <div className="page-content">
            <style>{`
                .custom-date-range-box {
                    margin: 0 10px 15px 0;
                }
            `}</style>
            <div className="container-fluid">
                <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5 className="m-0">Consumer Offer</h5>
                        <AddDiscount reloadDataSource={reloadDataSource} />
                    </Card.Header>
                    <Card.Body>
                        {HasPermission('ConsumerOffers.Read') ? (
                            <DataGrid
                                dataSource={dataSource()}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                key={refreshKey}
                                showBorders={true}
                                columnAutoWidth={true}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option('pager.visible', hasData);
                                    e.component.option('paging.visible', hasData);
                                }}
                                onRowPrepared={(e) => {
                                    if (e.rowType === 'data') {
                                        if (e.data.isActive) {
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0);
                                            const toDate = new Date(e.data.toDate);
                                            toDate.setHours(0, 0, 0, 0);
                                            if (toDate >= today) {
                                                e.rowElement.style.backgroundColor = '#D4EDDA';
                                                e.rowElement.style.color = '#155724';
                                            }
                                        }
                                    }
                                }}
                            >
                                <Scrolling mode="standard" useNative={true} scrollByContent={true} scrollByThumb={true} />
                                <Paging defaultPageSize={10} />
                                <Pager
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showPageSizeSelector={true}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />

                                <Toolbar>
                                    <ToolbarItem name="searchPanel" location="before" />
                                    <ToolbarItem
                                        location="before"
                                        render={() => (
                                            // <DateRangeBox
                                            //     width={300}
                                            //     defaultValue={['', '']}
                                            //     displayFormat="dd/MM/yyyy"
                                            //     showClearButton={true}
                                            //     acceptCustomValue={false}
                                            //     openOnFieldClick={true}
                                            //     applyButtonText="Apply"
                                            //     cancelButtonText="Cancel"
                                            //     deferRendering={false}
                                            //     dropDownOptions={{
                                            //         closeOnOutsideClick: false,
                                            //         hideOnOutsideClick: false,
                                            //     }}
                                            //     onValueChanged={onCurrentValueChange}
                                            //     elementAttr={{
                                            //         class: 'custom-date-range-box',
                                            //         style: { margin: '0 0px 15px 0' },
                                            //     }}
                                            // />
                                            <DateRangeBox
                                                width={300}
                                                value={dateRange}                 // ✅ controlled value
                                                displayFormat="dd/MM/yyyy"
                                                showClearButton={true}
                                                acceptCustomValue={false}
                                                openOnFieldClick={true}
                                                applyButtonText="Apply"
                                                cancelButtonText="Cancel"
                                                deferRendering={false}
                                                dropDownOptions={{
                                                    closeOnOutsideClick: false,
                                                    hideOnOutsideClick: false,
                                                }}
                                                onValueChanged={onCurrentValueChange}
                                                elementAttr={{
                                                    class: 'custom-date-range-box',
                                                    style: { margin: '0 0px 15px 0' },
                                                }}
                                            />
                                        )}
                                    />
                                </Toolbar>

                                <SearchPanel visible={true} width={240} placeholder="Search..." />
                                <HeaderFilter visible />
                                <Summary>
                                    <TotalItem />
                                </Summary>

                                <Column
                                    cssClass="mt-2"
                                    dataField="id"
                                    dataType="number"
                                    sortOrder="desc"
                                    visible={false}
                                    allowFiltering={false}
                                />
                                <Column cssClass="mt-2" dataField="status" caption="Status" dataType="string" width={200} />
                                <Column dataField="storeName" caption="Store" dataType="string" width={200} />
                                <Column dataField="promotionName" caption="Promotion" dataType="string" />
                                <Column dataField="materialType" caption="Material type" dataType="string" />
                                <Column dataField="mrpTypeName" caption="MRP Type" dataType="string" />
                                <Column dataField="discountOnSRPOption" caption="Discount on SRP" dataType="string" cssClass="text-center" />
                                <Column dataField="discountOnMRPOption" caption="Discount on MRP" dataType="string" cssClass="text-center" />
                                <Column dataField="discountType" caption="Discount Type" dataType="string" cssClass="text-center" />
                                <Column
                                    dataField="discountValue"
                                    caption="Discount Value"
                                    dataType="number"
                                    cssClass="text-center"
                                    cellRender={({ data }) => {
                                        if (data.discountValue == null) return '';
                                        const formattedValue = formatNumber(data.discountValue, '#,##0.00');
                                        return data.isPercentage ? `${formattedValue} %` : formattedValue;
                                    }}
                                />
                                <Column dataField="fromRange" caption="Invoice Range from" dataType="string" format="#,##0.00" cssClass="text-center" />
                                <Column dataField="toRange" caption="Invoice Range To" dataType="string" format="#,##0.00" cssClass="text-center" />
                                <Column
                                    dataField="fromDate"
                                    caption="From Date"
                                    dataType="string"
                                    cssClass="text-center"
                                    cellRender={({ data }) => moment(data.fromDate).format('DD/MM/YYYY')}
                                />
                                <Column
                                    dataField="toDate"
                                    caption="To Date"
                                    dataType="string"
                                    cssClass="text-center"
                                    cellRender={({ data }) => moment(data.toDate).format('DD/MM/YYYY')}
                                />
                                <Column
                                    cssClass="text-center"
                                    dataField="isDefault"
                                    caption="IsDefault"
                                    dataType="boolean"
                                    cellRender={({ data }) => <span>{data.isDefault ? 'Yes' : 'No'}</span>}
                                />
                                <Column
                                    cssClass="text-center"
                                    dataField="isClub"
                                    caption="Allow Offer Combination"
                                    dataType="boolean"
                                    cellRender={({ data }) => <span>{data.isClub ? 'Yes' : 'No'}</span>}
                                />
                            </DataGrid>
                        ) : null}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default DiscountMasterDataList;
